import React from 'react';

import { useFormContext } from 'react-hook-form';
import { InputAdornment } from '@mui/material';

import { LbInput, LbSelect, LbDatePicker, HeightInput } from '@infoods/lifebase-ui';

import classes from './AddScanManualForm.module.scss';
import { LbTimePicker } from '../../../shared/components/form-components';
import { CalculatedMetricInput } from './CalculatedMetricInput/CalculatedMetricInput';
import { EntryFieldConfig } from '../../interfaces/entityInbodyData';
import {
  AddScanManualFormValues,
  calculatedMetricConfigs,
  scanInputConfigs,
} from './AddScanManualForm.settings';

type AddScanManualFormProps = {
  entryFieldConfig: EntryFieldConfig;
  scanDateTitle: string;
  scanTimeTitle: string;
};

const AddScanManualForm = ({
  entryFieldConfig,
  scanDateTitle,
  scanTimeTitle,
}: AddScanManualFormProps) => {
  const { control } = useFormContext<AddScanManualFormValues>();

  const generalInputProps = {
    variant: 'standard',
    size: 'small',
    control,
  } as const;

  return (
    <>
      <LbDatePicker
        {...generalInputProps}
        name="scanData.scanDate"
        label={scanDateTitle}
        rules={{ required: `${scanDateTitle} is required` }}
        disableFuture
      />
      <LbTimePicker
        {...generalInputProps}
        name="scanData.scanTime"
        label={scanTimeTitle}
        rules={{ required: `${scanTimeTitle} is required` }}
      />
      <HeightInput
        {...generalInputProps}
        label="Height"
        name="scanData.height"
        rules={{ required: 'Height is required' }}
      />

      {scanInputConfigs.map((inputConfig) => {
        const props = {
          ...generalInputProps,
          name: inputConfig.name,
          label: inputConfig.label,
          rules: inputConfig.rules,
        };

        if (inputConfig.configField && !entryFieldConfig[inputConfig.configField]) {
          return null;
        }

        switch (inputConfig.type) {
          case 'SELECT_INPUT':
            return (
              <LbSelect
                {...props}
                key={inputConfig.name}
                options={inputConfig.options}
                rules={{ required: 'Field is required' }}
              />
            );
          case 'NUMBER_INPUT':
            return (
              <LbInput
                {...props}
                key={inputConfig.name}
                type="number"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className={classes.measureInfo}>
                      {inputConfig.measureUnit ?? entryFieldConfig.measureUnit}
                    </InputAdornment>
                  ),
                }}
              />
            );
          default:
            return null;
        }
      })}
      <div className={classes.calculatedRow}>
        {calculatedMetricConfigs.map((inputConfig) => {
          if (inputConfig.configField && !entryFieldConfig[inputConfig.configField]) {
            return null;
          }

          return (
            <CalculatedMetricInput
              key={inputConfig.name}
              {...generalInputProps}
              name={inputConfig.name}
              label={inputConfig.label}
              metric={inputConfig.measureUnit}
              deps={inputConfig.deps}
              calcFunction={inputConfig.calcFunction}
            />
          );
        })}
      </div>
    </>
  );
};

export { AddScanManualForm };
